export const Logout = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><path d="m24,3v18c0,1.654-1.346,3-3,3h-5v-2h5c.551,0,1-.449,1-1V3c0-.551-.449-1-1-1h-5V0h5c1.654,0,3,1.346,3,3Zm-15,18.273v-5.273H0v-8h9V2.729l8.28,7.576c.476.473.721,1.063.72,1.691,0,.627-.246,1.217-.691,1.66l-8.309,7.616Zm2-7.273v2.727l4.928-4.517c.059-.059.072-.162.072-.215,0-.054-.013-.156-.101-.244l-4.899-4.481v2.73H2v4h9Z" fill={props.color || '#000'} /></svg>
    );
};
export const ArrowUp = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><g id="_01_align_center" data-name="01 align center"><path d="M22.586,18.148,12.707,8.269a1.021,1.021,0,0,0-1.414,0L1.42,18.142.006,16.728,9.879,6.855a3.073,3.073,0,0,1,4.243,0L24,16.734Z" fill={props.color} /></g></svg>
    );
};
export const ArrowDown = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><g id="_01_align_center" data-name="01 align center"><path d="M22.586,5.929l-9.879,9.879a1.021,1.021,0,0,1-1.414,0L1.42,5.934.006,7.348l9.873,9.874a3.075,3.075,0,0,0,4.243,0L24,7.343Z" fill={props.color} /></g></svg>
    );
};

export const ShieldLocked = (props) => {
    return (
        <svg
            aria-hidden="true"
            {...props}
            width={props.width || 18}
            height={props.height || 20}
            viewBox="0 0 18 20"
            fill="none">
            <defs>
                <linearGradient id="productAttrIconGradient" x1="0.55" y1="0.577" x2="18.384" y2="18.092" gradientUnits="userSpaceOnUse">
                    <stop stopColor="var(--product-attr-icon-from, currentColor)" />
                    <stop offset="1" stopColor="var(--product-attr-icon-to, currentColor)" />
                </linearGradient>
            </defs>
            <path d="M8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 9.26667 15.9958 9.43334 15.9875 9.6C15.9792 9.76667 15.9667 9.93334 15.95 10.1C15.8 10.0667 15.6458 10.0417 15.4875 10.025C15.3292 10.0083 15.1667 10 15 10C13.6167 10 12.4375 10.4833 11.4625 11.45C10.4875 12.4167 10 13.6 10 15V19.25C9.68333 19.4167 9.35833 19.5625 9.025 19.6875C8.69167 19.8125 8.35 19.9167 8 20ZM12.85 20C12.6167 20 12.4167 19.9167 12.25 19.75C12.0833 19.5833 12 19.3833 12 19.15V15.85C12 15.6167 12.0833 15.4167 12.25 15.25C12.4167 15.0833 12.6167 15 12.85 15H13V14C13 13.45 13.1958 12.9792 13.5875 12.5875C13.9792 12.1958 14.45 12 15 12C15.55 12 16.0208 12.1958 16.4125 12.5875C16.8042 12.9792 17 13.45 17 14V15H17.15C17.3833 15 17.5833 15.0833 17.75 15.25C17.9167 15.4167 18 15.6167 18 15.85V19.15C18 19.3833 17.9167 19.5833 17.75 19.75C17.5833 19.9167 17.3833 20 17.15 20H12.85ZM14 15H16V14C16 13.7167 15.9042 13.4792 15.7125 13.2875C15.5208 13.0958 15.2833 13 15 13C14.7167 13 14.4792 13.0958 14.2875 13.2875C14.0958 13.4792 14 13.7167 14 14V15Z" fill={props.color || "url(#productAttrIconGradient)"} /></svg>
    );
};

export const UsageCheck = (props) => {
    return (
        <svg
            aria-hidden="true"
            {...props}
            width={props.width || 20}
            height={props.height || 20}
            viewBox="2 2 20 20"
            fill="none">
            <defs>
                <linearGradient id="productAttrUsageGradient" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                    <stop stopColor="var(--product-attr-icon-from, currentColor)" />
                    <stop offset="1" stopColor="var(--product-attr-icon-to, currentColor)" />
                </linearGradient>
            </defs>
            <circle cx="12" cy="12" r="10" fill={props.color || "url(#productAttrUsageGradient)"} />
            <path d="M8.2 12.13L10.8 14.89L15.8 9.07" stroke="#FFFFFF" strokeWidth="1.34" strokeLinecap="round" strokeLinejoin="round" /></svg>
    );
};
